var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"schoolSection"},[_c('Headline'),_c('Headline2'),_c('LessonPlan'),_c('Teacher'),_c('Curriculum'),_c('Student'),_c('SchoolYear'),_c('LessonTemplates'),_c('Signup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }